import React from "react";
import PropTypes from "prop-types";
import "../styles/data-message.scss";

const propTypes = {
  dataMsg: PropTypes.string.isRequired,
  clientLogo: PropTypes.string.isRequired
};

function DataMessage(props) {
  const { dataMsg, clientLogo } = props;
  return (
    <>
      <div
        className="image-watermark"
        style={{
          backgroundImage: `url(${clientLogo})`
        }}
      />
      <h4 className="info-data-msg">{dataMsg}</h4>
    </>
  );
}

DataMessage.propTypes = propTypes;

export default DataMessage;
